//global dawn functions
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function loaderSpinner(isshow) {
  if (isshow) {
    document.querySelector('.loader').style.display='block';
  }
  else {
    document.querySelector('.loader').style.display='none';
  }
}

//options
const filterOptions = {
  useCache : true  // true or false
}
var filterData=[]; //this cache for store already filtered data
var searchParamsInitial = window.location.search.slice(1);
var searchParamsPrev = window.location.search.slice(1);
var _priceSlider;
if (document.querySelector('[data-filters-active]')) {
  initFilterSd();
}

function initFilterSd() {
  //add listeners
  // history lsitener for back/next button
  const onHistoryChange = (event) => {
    const searchParams = event.state ? event.state.searchParams : searchParamsInitial;
    if (searchParams === searchParamsPrev) return;
    renderPage(searchParams, null, false);
  };
  window.addEventListener('popstate', onHistoryChange);

  // filter value click  
  const filterContainer = document.querySelector('[data-container="filters"]');

  function handleFilterEvent(e) {
    if (e.target.tagName === "INPUT" && 
        e.target.name !== 'filter.v.price.gte' && 
        e.target.name !== 'filter.v.price.lte') {
      renderFilterData(e);
    }
  }

  // Handle clicks
  filterContainer.addEventListener('click', handleFilterEvent);

  // Handle keyboard enter
  filterContainer.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && e.target.type === 'checkbox') {
      // Toggle the checkbox
      e.target.checked = !e.target.checked;
      // Trigger the filter update
      handleFilterEvent(e);
    }
  });

  document.querySelector('[data-filters-active]').addEventListener('click', function (e) {
    const el=e.target.dataset.activefilter || (e.target.closest('[data-activefilter]') && e.target.closest('[data-activefilter]').dataset.activefilter);
    if(el) {
      if (e.target.dataset.priceremove || (e.target.closest('[data-priceremove]') && e.target.closest('[data-priceremove]').dataset.priceremove)) {
        //_priceSlider.noUiSlider.reset();
        const minEl=document.querySelector('[data-filterminparam]'); 
        const maxEl=document.querySelector('[data-filtermaxparam]');	
        if (minEl) minEl.value='';
        if (maxEl) maxEl.value='';          
      }
      renderPage(el.indexOf('?') == -1? "" : el.slice(el.indexOf('?') + 1));
    }
  });

  document.querySelectorAll('[data-sort-container]').forEach(function(container) {
    container.addEventListener('click', handleSort);
    container.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.classList.contains('filter-sort__item')) {
        handleSort(e);
      }
    });

    function handleSort(e) {
      if (e.target.classList.contains('filter-sort__item')) {
        const el = e.target.dataset.sortby;
        if (el) {
          container.querySelectorAll('.filter-sort__item').forEach(function(item) { 
            if (item !== e.target) item.classList.remove('filter-sort__item--active');
          });
          e.target.classList.add('filter-sort__item--active');
          container.previousElementSibling.querySelector('span').innerText = e.target.innerText;
          renderFilterData(e);
        }
      }
    }
  });

  document.querySelectorAll('[data-clearfilter]').forEach(element => {
    element.addEventListener('click', function (e) {
      const formData = new FormData();
      document.querySelectorAll('[data-container="filters"] [data-filter-search]').forEach((element) => {
        formData.append(element.name,element.value);
      });  
      const searchParams=new URLSearchParams(formData).toString();
      renderPage(searchParams);        
    });
  });

   document.querySelectorAll('[data-clearprice]').forEach(element => {
    element.addEventListener('click', function (e) {
       const minEl=document.querySelector('[data-filterminparam]'); 
       const maxEl=document.querySelector('[data-filtermaxparam]');	
       minEl.value='';
       maxEl.value='';
       renderFilterData();
    });
  });
  
  initPriceSlider();
  document.querySelector('[data-filterminparam]').addEventListener('change',renderFilterData);
  document.querySelector('[data-filtermaxparam]').addEventListener('change',renderFilterData);
  renderAdditionalData();
}


function initPriceSlider() {
  const priceRangeEl=document.querySelector('[data-filter-price]');
  if (priceRangeEl) {
  var currencySymbol='£';

  const minEl=document.querySelector('[data-filterminparam]'); 
  const maxEl=document.querySelector('[data-filtermaxparam]');	  
  const minPrice=minEl && minEl.value!=''?minEl.value: 0;
  const maxPrice=maxEl && maxEl.value!=''?maxEl.value:priceRangeEl.dataset.filtermax;
  
  _priceSlider = document.getElementById('slider-range');
   if (_priceSlider) {
     if ($("#slider-range").get(0).noUiSlider != undefined) {
                $("#slider-range").get(0).noUiSlider.destroy();
            }
	noUiSlider.create(_priceSlider, {
    	start: [parseInt(minPrice),parseInt(maxPrice)],
    	connect: true,
    	range: {
        	'min':  0,
        	'max':parseInt(priceRangeEl.dataset.filtermax)
    	}
	});
  
  	_priceSlider.noUiSlider.on('set', function (values, handle, unencoded, isTap, positions) {
          document.querySelector('[data-filterminparam]').value=values[0]; 
          document.querySelector('[data-filtermaxparam]').value=values[1];			         		            
          renderFilterData();
	});

    
  }
  }
}
function renderPage(searchParams, event){
  searchParamsPrev = searchParams;
  //build url
  const section=document.querySelector('[data-collection-container]').dataset.id; // get section to retrive only collection section instead of whole page
  const url = `${window.location.pathname}?section_id=${section}&${searchParams}`; 
  //put to history state so we can use prev/next browser button
  history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  //fetch html for filtered data
  //here need put show loading overlay
   const filterDataUrl = (element) => element.url === url; // create new cache element for check is this this url already in cache
   (filterOptions.useCache === true && filterData.some(filterDataUrl))
        ? renderSectionFromCache(filterDataUrl, event)
        : renderSectionFromFetch(url, event);
}
function renderFilterData(e) {
  //serialize filters container for get form data
  const formData = new FormData();
  //get all filter value
  document.querySelectorAll('[data-container="filters"] input:checked').forEach((element) => {
    formData.append(element.name,element.value);
  });
  document.querySelectorAll('[data-container="filters"] [data-filter-search]').forEach((element) => {
    formData.append(element.name,element.value);
  });
  //get price filter
  const minEl=document.querySelector('[data-filterminparam]'); 
  const maxEl=document.querySelector('[data-filtermaxparam]');	
  if (minEl && maxEl && (minEl.value!=minEl.dataset.filterminparam || maxEl.value!=maxEl.dataset.filtermaxparam)) {
    if (minEl.value!='') formData.append(minEl.name,minEl.value);
    if (maxEl.value!='') formData.append(maxEl.name,maxEl.value);
  }
  //get sortby
  const sortEl=document.querySelector('[data-sortby].filter-sort__item--active');
  if (sortEl) {
    formData.append("sort_by",sortEl.dataset.sortby);
    if (sortEl.dataset.sortby == "best-selling") {
      formData.append("filter.p.m.accentuate.not_discontinued","1");
    }
  }
  //generate searchparam string
  const searchParams=new URLSearchParams(formData).toString();
  renderPage(searchParams,e);
}

function renderSectionFromFetch(url, event) {
    loaderSpinner(true);
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        if (filterOptions.useCache === true ) 
          filterData = [...filterData, { html, url }]; // put to cache
        renderFilters(html, event);
        renderProductContainer(html);
        renderProductCount(html);
        renderAdditionalData();
        loaderSpinner(false);
      });
  }

function renderSectionFromCache(filterDataUrl, event) {
    const html = filterData.find(filterDataUrl).html;
    renderFilters(html, event);
    renderProductContainer(html);
    renderProductCount(html);
    renderAdditionalData();
}


function renderProductContainer(html) {
    document.querySelector('[data-collection-container]').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('[data-collection-container]').innerHTML;

    document.querySelectorAll('[data-collection-container] [data-clearfilter]').forEach(element => {
    element.addEventListener('click', function (e) {
      const formData = new FormData();
      document.querySelectorAll('[data-container="filters"] [data-filter-search]').forEach((element) => {
        formData.append(element.name,element.value);
      });  
      const searchParams=new URLSearchParams(formData).toString();
      renderPage(searchParams);        
    });
  });
}

function renderProductCount(html) {
  const count = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-count-container]').innerHTML;
  const containers = document.querySelectorAll('[data-count-container]'); // Select all instances

  containers.forEach(container => {
      container.innerHTML = count; // Update each container's innerHTML with the new count
  });
  // Add Filter Count
  const activeFilters = document.querySelectorAll('[data-activefilter]').length;
  const filterCount = document.querySelectorAll('[data-filter-count]');

  filterCount.forEach(function(element) {
    if (activeFilters === 0) {
      element.style.display = 'none';
    } else {
      element.style.display = 'flex';
      element.innerText = activeFilters;
    }
  });
}

function renderFilters(html, event) {
  
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
  const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
    '[data-filter]'
  );
  const facetDetailsElementsFromDom = document.querySelectorAll(
    '[data-filter]'
  );

  // Remove filters that are no longer returned from the server, this mostly for OR logic
  Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
    if (!Array.from(facetDetailsElementsFromFetch).some(({ dataset }) => currentElement.dataset.filter === dataset.filter)) {
      currentElement.remove();
    }
  });

  //function for check and not rerender current filter group (where user select last filter value)
  const matchesId = (element) => {
    const jsFilter = event ? event.target.closest('[data-filter]') : undefined;
    return jsFilter ? element.dataset.filter === jsFilter.dataset.filter : false;
  };
  const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
  const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

  facetsToRender.forEach((elementToRender, index) => {
    const currentElement = document.querySelector(`[data-filter="${elementToRender.dataset.filter}"]`);      
    // Element already rendered in the DOM so just update the innerHTML
    if (currentElement) {
      if (currentElement.querySelector('[data-filter-list]')==null) {
        currentElement.querySelector('[data-filterminparam]').value = elementToRender.querySelector('[data-filterminparam]').value;   
        currentElement.querySelector('[data-filtermaxparam]').value = elementToRender.querySelector('[data-filtermaxparam]').value;              
      }
      else {
         currentElement.querySelector('[data-filter-list]').innerHTML = elementToRender.querySelector('[data-filter-list]').innerHTML;   
      }
     
    } else {
      if (index > 0) {                  
         const prevElement=document.querySelector(`[data-filter="${parsedHTML.querySelector(`[data-filter="${facetsToRender[index].dataset.filter}"]`).previousElementSibling.dataset.filter}"]`);          
         prevElement.after(elementToRender.cloneNode(true));
      }        
    }
  });
  initPriceSlider();

  const parsedDom=new DOMParser()
  .parseFromString(html, 'text/html');
  
  //render active filters
  const activeFiltersDom=parsedDom.querySelector('[data-filters-active]');
  document.querySelector('[data-filters-active]').innerHTML =activeFiltersDom ? parsedDom.querySelector('[data-filters-active]').innerHTML:"";

  // render pagination
  const paginationDom=parsedDom.querySelector('[data-paginate-container]');
  document.querySelector('[data-paginate-container]').innerHTML =paginationDom ? paginationDom.innerHTML:'';
  
  //render clear all
  const activeFilters = document.querySelectorAll('[data-activefilter]').length;
  const clearAll = document.querySelectorAll('[data-clearfilter]'); // Multiple elements

  clearAll.forEach((element) => {
    if (activeFilters === 0) {
      element.style.display = 'none';
      element.parentNode.classList.add('inactive');
      element.parentNode.parentNode.classList.add('inactive');
    } else {
      element.innerText = "Clear all (" + activeFilters + ")";
      element.style.display = 'flex';
      element.parentNode.classList.remove('inactive');
      element.parentNode.parentNode.classList.remove('inactive');
    }
  });
  
}

function renderAdditionalData() {
  //this for additional data render : swatches,overlays from graphql etc..
  loadswatches();
  _initFilter();
  _initCompare();
  if (window.ReloadSmartWishlist!=undefined) {
        ReloadSmartWishlist();
  }
  initVatToggle();
  //here need put hide loading overlay
  
}


//search functions
const searchOptions= {
   searchFormSelector: '[data-searchform]',
   useCache : true  // true or false
}

let searchCachedResults = {},    
    searchIsOpen = false,
    searchAbortController = new AbortController(),
    searchSearchTerm = '',
    searchForm,
    predictiveSearchResults,
    resultsMaxHeight ;

function initSearchSd() {

    searchForm=document.querySelector(searchOptions.searchFormSelector);
    predictiveSearchResults = searchForm.querySelector('[data-predictive-search]')
    //searchForm.addEventListener('submit', this.onFormSubmit.bind(this));

    //this.input.addEventListener('focus', this.onFocus.bind(this));
    //this.addEventListener('focusout', this.onFocusOut.bind(this));
    //this.addEventListener('keyup', this.onKeyup.bind(this));
    //this.addEventListener('keydown', this.onKeydown.bind(this));
    let searchInput=searchForm.querySelector('input[type="search"]');
    searchInput.addEventListener(
        'input',
        debounce((event) => {
          searchOnChange(event);
        }, 300)
    );

    searchForm.querySelector('button[type="reset"]').addEventListener(
        'click',
        function() {
          searchInput.value='';
          searchOnChange();
          toggleResetButton();
        }
    );
}


function searchGetQuery() {  
    return  searchForm.querySelector('input[type="search"]').value.trim();
}

function  searchOnChange() {
    const newSearchTerm = searchGetQuery();
    if (!searchSearchTerm || !newSearchTerm.startsWith(searchSearchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      searchForm.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    updateSearchForTerm(searchSearchTerm, newSearchTerm);

    searchSearchTerm = newSearchTerm;

    if (!searchSearchTerm.length) {
      closeSearchPredict(true);
      return;
    }

    getSearchResults(searchSearchTerm);
    toggleResetButton() ;
}

 function updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = searchForm.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

 function getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    //this.setLiveRegionLoadingState();

    if (searchCachedResults[queryKey]) {
      renderSearchResults(searchCachedResults[queryKey]);
      return;
    }

    fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
      signal: searchAbortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          closeSearchPredict();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;                
          searchCachedResults[queryKey] = resultsMarkup;        
        renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        closeSearchPredict();
        throw error;
      });
  }

function renderSearchResults(resultsMarkup) {
    predictiveSearchResults.innerHTML = resultsMarkup;
    const groupsWrapper = predictiveSearchResults.querySelector('#predictive-search-results-groups-wrapper');
    // Check if results container exists and has content
    const hasResults = groupsWrapper && groupsWrapper.children.length > 0;
    if (hasResults) {
        openSearchPredict();
    } else {
        closeSearchPredict();
    }
}

function getResultsMaxHeight() {
    resultsMaxHeight =
      window.innerHeight - document.querySelector('header').getBoundingClientRect().bottom;
    return resultsMaxHeight;
  }

function  openSearchPredict() {
    predictiveSearchResults.style.maxHeight = resultsMaxHeight || `${getResultsMaxHeight()}px`;
    //this.setAttribute('open', true);
    //this.input.setAttribute('aria-expanded', true);
    searchIsOpen = true;
    document.querySelector(".header-search__form").classList.add("header-search__form--open");
    document.querySelector("html").classList.add("no-scroll-search");
    initVatToggle();
  }

function closeSearchPredict(clearSearchTerm = false) {
    closeSearchPredictResults(clearSearchTerm);
    searchIsOpen = false;
    document.querySelector(".header-search__form").classList.remove("header-search__form--open");
    document.querySelector("html").classList.remove("no-scroll-search");
  }

function closeSearchPredictResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      searchForm.querySelector('input[type="search"]').value = '';
      //this.removeAttribute('results');
    }
    //const selected = this.querySelector('[aria-selected="true"]');

    //if (selected) selected.setAttribute('aria-selected', false);

    //this.input.setAttribute('aria-activedescendant', '');
    //this.removeAttribute('loading');
    //this.removeAttribute('open');
   // this.input.setAttribute('aria-expanded', false);
    resultsMaxHeight = false;
    predictiveSearchResults.removeAttribute('style');
  //}
}

  $(document).click(function(event) {
    // Check if the clicked element is outside .header-search__form
    if (!$(event.target).closest('.header-search__form').length) {
      $('.header-search__form').removeClass('header-search__form--open');
      document.querySelector("html").classList.remove("no-scroll-search");
      //$('.header-search__reset').addClass('hidden');
      searchIsOpen = false;
    }
  });

 function toggleResetButton() {
    const resetButton=searchForm.querySelector('button[type="reset"]');
    const resetIsHidden = resetButton.classList.contains('hidden');
    if (searchGetQuery().length > 0 && resetIsHidden) {
      resetButton.classList.remove('hidden');
    } else if (searchGetQuery().length === 0 && !resetIsHidden) {
      resetButton.classList.add('hidden');
    }
  }

initSearchSd();